import { ACCOUNTING_DAY_ROUTING } from "constants/actionTypes";

import { serializeAccountingDayRouting } from "lib/serializers/accountingDayRouting";

import { offlineActionCreator, offlineSubActionCreator } from "./lib";

export interface AccountingDayRoutingRequest {
  livestockSaleId: string | number;
}

export interface AccountingDayRoutingConfirmRequest {
  livestockSaleId: string | number;
  cashBuyerIds: string[];
  individualBuyerIds: string[];
}

export const getAccountingDayRoutingUrl = ({
  livestockSaleId,
}: AccountingDayRoutingRequest) =>
  `/v2/clearing-sale/${livestockSaleId}/accounting-day-routing/`;

export const AccountingDayRoutingAction = offlineActionCreator(
  ACCOUNTING_DAY_ROUTING,
  serializeAccountingDayRouting,
  getAccountingDayRoutingUrl,
  false,
);

AccountingDayRoutingAction.confirm = offlineSubActionCreator(
  ACCOUNTING_DAY_ROUTING.CONFIRM,
  ({ livestockSaleId }: AccountingDayRoutingConfirmRequest) =>
    `/v2/clearing-sale/${livestockSaleId}/accounting-day-routing/confirm/`,
  "POST",
  ({
    cashBuyerIds,
    individualBuyerIds,
  }: AccountingDayRoutingConfirmRequest) => ({
    cash_buyer_ids: cashBuyerIds,
    individual_buyer_ids: individualBuyerIds,
  }),
);
